//#region IMPORT
import React, { useEffect, useRef, useState } from 'react';
import M_TBG_CUSTOM_02 from './M_TBG_CUSTOM_02';
import { useDispatch, useSelector } from 'react-redux';
import { CommonActions } from '../../../../Reducer/CommonReducer';
// useBackStack 훅 임포트
import { useBackStack } from '../../../../Hooks/back/useBackStack';
import { useSearch1, useSearch2, useSave1 } from './M_TBG_CUSTOM_02_Query';
import { useSave } from '../../../../Hooks/useSave';
//#endregion

function M_TBG_CUSTOM_02F(props) {
  //#region 변수
  const dispatch = useDispatch();
  const { userInfo, lanInfo } = useSelector((state) => state.BaseInfo);
  const activeStep = useSelector((state) => state.common.activeStep);

  // onBack 클로저 이슈 해결을 위한 activeStepRef 사용
  const activeStepRef = useRef(activeStep);
  useEffect(() => {
    activeStepRef.current = activeStep;
  }, [activeStep]);

  const [snackbar, setSnackbar] = useState({
    open: false,
    message: '',
    type: 'info',
  });
  const [rowData, setRowData] = useState([]);
  const [modalToggle1, setModalToggle1] = useState(false);
  const [qrcode, setQrcode] = useState();
  const [value, setValue] = useState(0);
  const [state, setState] = useState({ bottom: false, type: '' });
  const [duration, setDuration] = useState(600);
  const [current, setCurrent] = useState(0);
  //#endregion

  // 뒤로가기 핸들러 수정: useBackStack 적용
  useBackStack({
    type: 'custom',
    onBack: () => {
      // 1. 모달이 열려있으면 모달 닫기
      if (modalToggle1 === true) {
        setModalToggle1(false);
        return;
      }

      // 2. Step 1로 롤백 및 저장 로직 실행
      Save1([{ eStep: '1', mStep: '0', tbmCd: props.tbmCdRef.current }]);

      props.ActiveButton({
        type: 'prev',
        content: true,
        step: 0,
      });

      // 3. 리덕스 상태 변경
      dispatch(CommonActions.setActiveStep(activeStepRef.current - 1));
    },
  });

  //#region 이벤트
  useEffect(() => {
    Init();
  }, []);

  useEffect(() => {
    if (props.startTimeRef?.current) {
      const updateTime = () => {
        const now = new Date();
        const elapsedSeconds = Math.max(
          0,
          Math.floor(
            (now.getTime() - props.startTimeRef.current?.getTime()) / 1000
          )
        );
        setCurrent(elapsedSeconds);
      };
      updateTime();
      const interval = setInterval(updateTime, 1000);
      return () => clearInterval(interval);
    }
  }, [props.startTimeRef?.current]);

  const Init = async () => {
    try {
      await Search1Async({ tbmCd: props.tbmCdRef?.current });
    } catch (e) {
      console.log(e);
      setSnackbar({
        ...snackbar,
        open: true,
        message: e?.message,
        type: 'error',
      });
    }
  };
  //#endregion

  //#region 쿼리 (기존 로직 유지)
  const { runAsync: Search1Async } = useSearch1({
    onSuccess: (rows) => {
      setRowData(rows);
    },
  });
  const { runAsync: Search2Async } = useSearch2({
    onSuccess: (rows) => {
      setQrcode(rows[0].tbmCd);
    },
  });
  const { runAsync: Save1Async } = useSave1();

  const { run: Save1 } = useSave({
    menuId: 'M_TBG_CUSTOM_02',
    requestSave: (rows) => Save1Async(rows),
  });
  //#endregion

  //#region 나머지 함수
  const HandleChange = (event, newValue) => setValue(newValue);
  //#endregion

  return (
    <M_TBG_CUSTOM_02
      userInfo={userInfo}
      lanList={lanInfo}
      rowData={rowData}
      setRowData={setRowData}
      modalToggle1={modalToggle1}
      setModalToggle1={setModalToggle1}
      qrcode={qrcode}
      setQrcode={setQrcode}
      value={value}
      setValue={setValue}
      state={state}
      setState={setState}
      duration={duration}
      setDuration={setDuration}
      current={current}
      setCurrent={setCurrent}
      activeStep={activeStep}
      setActiveStep={(step) => dispatch(CommonActions.setActiveStep(step))}
      userCount={props.userCount}
      setUserCount={props.setUserCount}
      check={props.check}
      setCheck={props.setCheck}
      tbmCdRef={props.tbmCdRef}
      SearchLogic2={Search2Async}
      SaveLogic1={Save1}
      HandleChange={HandleChange}
      ActiveButton={props.ActiveButton}
    />
  );
}

export default M_TBG_CUSTOM_02F;
